var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { isTileset } from "./Tileset";
import { FileLoader } from "../../loaders";
import { ResourceSource } from "../../../objects/tileset_3d/Tileset3D/ResourceSource";
export * from "./Asset";
export * from "./BoundingVolume";
export * from "./Content";
export * from "./Property";
export * from "./Tile";
export * from "./Tileset";
/**
 * Returns whether obj matches the Extensions interface
 * @param obj
 */
export function isExtensions(obj) {
    if (obj === null)
        return false;
    if (typeof obj !== "object")
        return false;
    for (const e of Object.values(obj)) {
        if (typeof e !== "object")
            return false;
    }
    return true;
}
/**
 * Returns whether obj matches the Impl interface
 * @param obj
 */
export function isImpl(obj) {
    if (obj === null)
        return false;
    if (typeof obj !== "object")
        return false;
    for (const e of Object.values(obj)) {
        if (typeof e !== "object")
            return false;
    }
    return true;
}
/**
 * This function performs an asynchronous fetch of a 3d tiles tileset.json from the requested URL.
 *
 * This function will also add an implementation metadata item to the tileset object under `tileset.impl.tilesetSource`
 *
 * @param url
 */
export function fetchTileset(url, absolute) {
    return __awaiter(this, void 0, void 0, function* () {
        const response = yield FileLoader.loadJson(url);
        if (!isTileset(response)) {
            throw new Error("Response does not match tileset interface");
        }
        // Add a metadata field to the tileset to track the URL we got it from, we need this for resolving relative
        // URL paths.
        const tileset = response;
        tileset.extras = {
            source: ResourceSource.fromDirectEndpoint(url, absolute),
        };
        return tileset;
    });
}
